import { render, staticRenderFns } from "./PaginationNumeric.vue?vue&type=template&id=09dc2ec6&scoped=true"
import script from "./PaginationNumeric.vue?vue&type=script&lang=js"
export * from "./PaginationNumeric.vue?vue&type=script&lang=js"
import style0 from "./PaginationNumeric.vue?vue&type=style&index=0&id=09dc2ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc2ec6",
  null
  
)

export default component.exports